import React from 'react'

import { EventElement, DataElement, AnnotationElement } from './Elements'

const FlowchartElement = ({
  element = {
    color: 'black',
    textColor: 'black',
    type: 'annotation',
    id: '',
    relations: [],
  },
}) => {
  const isEventType = element.type === 'event'
  const isDataType = element.type === 'data'
  const isAnnotationType = element.type === 'annotation'

  return (
    <>
      {isEventType && <EventElement element={element} />}
      {isDataType && <DataElement element={element} />}
      {isAnnotationType && <AnnotationElement element={element} />}
    </>
  )
}

export default FlowchartElement
